import {useState, useEffect} from 'react';
import './fileUpload.css';
import {
    addMetadataToFile,
    extractUrlFromFileName,
    formatDimensions,
    handleExtractDimensions,
    handleImageDimensions,
    handleVideoDimensions
} from '../util/extractDimensions/extractDimensions';

const FileUploadTable = ({uploadedFiles, handleuploadedFiles, setFileData, fileData, handleSizeClick}) => {
    const [defaultUrl, setDefaultUrl] = useState()

    useEffect(() => {
        const fetchAndSetFileData = async () => {
            const extractedFileData = Object.keys(uploadedFiles).map((key, index) => {
                const {name, url} = extractUrlFromFileName(uploadedFiles[index])
                const file = uploadedFiles[key];
                return {
                    name: name,
                    size: file.size,
                    url: url || defaultUrl,
                    sizeFormatted: `${(file.size / 1024).toFixed(2)} KB`,
                    ...file,
                };
            });
            let dimensionsResult = [];
            const dimensionsPromises = extractedFileData.map(async (file, index) => {
                if (uploadedFiles[index].type?.indexOf('image') > -1) {
                    const imageDimension = await handleImageDimensions(uploadedFiles[index]);
                    return imageDimension ? `${imageDimension.width} x ${imageDimension.height}` : '--';
                } else if (uploadedFiles[index].type === 'video/mp4') {
                    const videoDimension = await handleVideoDimensions(uploadedFiles[index]);
                    return videoDimension ? `${videoDimension.width} x ${videoDimension.height}` : '--';
                } else if (uploadedFiles[index].type === 'application/x-zip-compressed') {
                    const dimension = await handleExtractDimensions(uploadedFiles[index]);
                    return (dimension?.width && dimension?.height)
                        ? formatDimensions(dimension)
                        : '--';
                } else {
                    return '--';
                }
            });
            dimensionsResult = await Promise.all(dimensionsPromises);

            setFileData({
                name: extractedFileData.map((file) => file.name),
                landingPages: extractedFileData.map((file) => file.url),
                adSizes: extractedFileData.map((file) => file.sizeFormatted),
                dimensions: dimensionsResult,
            });
        };

        fetchAndSetFileData();
    }, [uploadedFiles]);

    const removeFile = (key) => {
        let newFiles = {
            name: [],
            landingPages: [],
            adSizes: [],
            dimensions: []
        }
        for (let i = 0; i < fileData['name'].length; i++) {
            if (i !== key) {
                newFiles['name'].push(fileData['name'][i]);
                newFiles['landingPages'].push(fileData['landingPages'][i]);
                newFiles['adSizes'].push(fileData['adSizes'][i]);
                newFiles['dimensions'].push(fileData['dimensions'][i]);
            }
        }
        setFileData(newFiles);
    }

    const handleInputChange = async (value, index, key) => {
        // const updatedData = [...fileData[key]];
        // updatedData[index] = value;
        // setFileData((prevState) => ({
        //   ...prevState,
        //   [key]: updatedData,
        // }));

        if (key === "name") {
            const updatedFiles = [...uploadedFiles];
            const fileToUpdate = updatedFiles[index];
            const {name, url} = await extractUrlFromFileName(fileToUpdate)
            const values = url ? `${value}?url=${encodeURIComponent(url)}` : `${value}`;

            const updatedFile = new File([fileToUpdate], values, {
                type: fileToUpdate.type,
                lastModified: fileToUpdate.lastModified
            });
            updatedFiles[index] = updatedFile;
            handleuploadedFiles(updatedFiles)
        }
        if (key === "landingPages") {
            setDefaultUrl(value)
            const updatedFiles = [...uploadedFiles];
            const fileToUpdate = updatedFiles[index];
            const {name, url} = await extractUrlFromFileName(fileToUpdate)
            const values = `${name}?url=${encodeURIComponent(value)}`;

            const updatedFile = new File([fileToUpdate], values, {
                type: fileToUpdate.type,
                lastModified: fileToUpdate.lastModified
            });
            updatedFiles[index] = updatedFile;
            handleuploadedFiles(updatedFiles)
        }
    };

    const cleanedUpFileName = (fileName) => {
        return fileName.replace(/\.[^/.]+$/, "")
    }

    const getFileExtension = (fileName) => {
        var ext = /^.+\.([^.]+)$/.exec(fileName);
        return ext == null ? "" : ext[1];
    }

    return (
        <>
            <div className="Filtypeblock-container">
                <div className="Filtypeblock-action">
                    <div className="title-name">File</div>
                    {fileData.name.map((file, index) => (
                        <div className="file-name-container">
                            <input
                                key={index}
                                type="text"
                                className="button-typeimg"
                                value={cleanedUpFileName(file)}
                                onChange={(e) => handleInputChange(e.target.value, index, 'name')}
                            />
                            <span className="file-extension">.{getFileExtension(file)}</span>
                        </div>
                    ))}
                </div>
                <div className="Filtypeblock-action">
                    <div className="title-name">File Size</div>
                    {fileData.adSizes.map((adSize, index) => (
                        <input
                            key={index}
                            type="text"
                            className="button-typeimg"
                            value={adSize}
                            readOnly
                        />
                    ))}
                </div>
                <div className="Filtypeblock-action">
                    <div className="title-name">Ad Dimensions</div>
                    {fileData?.dimensions?.map((adDimensions, index) => (
                        <input
                            key={index}
                            type="text"
                            className="button-typeimg"
                            value={adDimensions}
                            readOnly
                        />
                    ))}
                </div>
                <div className="Filtypeblock-action">
                    <div className="title-name">Landing Page</div>
                    {fileData.landingPages.map((landingPage, index) => (
                        <input
                            key={index}
                            defaultValue={'https://example.com/landing'}
                            placeholder='https://example.com/landing'
                            type="text"
                            className="button-typeimg"
                            value={landingPage}
                            onChange={(e) => handleInputChange(e.target.value, index, 'landingPages')}
                        />
                    ))}
                </div>
                <div className="actions-column">
                    {fileData.name.map((file, index) => (
                        <a href="#"
                           key={index}
                           onClick={(e) => removeFile(index)}>
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100"
                                 viewBox="0 0 24 24">
                                <path
                                    d="M 10.806641 2 C 10.289641 2 9.7956875 2.2043125 9.4296875 2.5703125 L 9 3 L 4 3 A 1.0001 1.0001 0 1 0 4 5 L 20 5 A 1.0001 1.0001 0 1 0 20 3 L 15 3 L 14.570312 2.5703125 C 14.205312 2.2043125 13.710359 2 13.193359 2 L 10.806641 2 z M 4.3652344 7 L 5.8925781 20.263672 C 6.0245781 21.253672 6.877 22 7.875 22 L 16.123047 22 C 17.121047 22 17.974422 21.254859 18.107422 20.255859 L 19.634766 7 L 4.3652344 7 z"></path>
                            </svg>
                        </a>
                    ))}
                </div>
            </div>
        </>
    );
};

export default FileUploadTable;
